import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon, FlameIcon } from 'lucide-react';
import { HotLeadList } from './components/HotLeadList/HotLeadList';
import { HotLeads } from './pages/HotLeads';
import { HotLeadProvider, useHotLeads } from './contexts/HotLeadContext';
type View = 'console' | 'hotLeads';
export function App() {
  return <HotLeadProvider data-id="element-0" data-mp="3fb9it9bilamk">
      <Workspace data-id="element-1" data-mp="3f8nf5krqvf9m" />
    </HotLeadProvider>;
}
function Workspace() {
  const [view, setView] = useState<View>('hotLeads');
  const [isPanelOpen, setIsPanelOpen] = useState(true);
  const {
    pending,
    urgentCount
  } = useHotLeads();
  return <div className="flex min-h-screen w-full flex-col bg-[#f3f3f3]" data-id="element-2" data-mp="31ayq00qn9lyr">
      <header className="flex items-center gap-4 bg-[#0b5cab] px-4 py-2 text-white" data-id="element-3" data-mp="2wk06ksad07ra">
        <span className="text-sm font-semibold" data-id="element-4" data-mp="2wi5l9cv6edmo">Valorem Lending</span>
        <nav aria-label="App navigation" className="flex gap-4 text-xs" data-id="element-5" data-mp="28suveqfd63nb">
          <NavItem label="Lead Console" isActive={view === 'console'} onClick={() => setView('console')} data-id="element-6" data-mp="23u9tmmkgrbwr" />
          <NavItem label="Hot Lead List" isActive={view === 'hotLeads'} onClick={() => setView('hotLeads')} data-id="element-7" data-mp="3ii4r9zs8ioni" />
          <span className="pb-0.5 text-white/60" data-id="element-8" data-mp="3rdkisa5iorpx">Reports</span>
        </nav>
      </header>

      <div className="flex-1" data-id="element-9" data-mp="4wxfu7a14id">
        {view === 'hotLeads' ? <HotLeads onBack={() => setView('console')} data-id="element-10" data-mp="2zld0l5ad579f" /> : <main className="px-6 py-6" data-id="element-11" data-mp="2zn6b4vo3kbmp">
            <h1 className="text-lg font-semibold text-slate-900" data-id="element-12" data-mp="33m5cy7ej7s9x">Lead Console</h1>
            <p className="mt-1 max-w-xl text-sm text-slate-600" data-id="element-13" data-mp="38lrpsfqg76i7">
              The hot lead list lives in the utility bar so it stays visible anywhere
              in Salesforce. Open the full page for touch history, demotions, and DNQ.
            </p>
          </main>}
      </div>

      <div className="sticky bottom-0 border-t border-slate-300 bg-[#f3f3f3]" data-id="element-14" data-mp="nxx05t81tyze">
        {isPanelOpen && <div className="mx-auto h-[26rem] w-full max-w-4xl px-4" data-id="element-15" data-mp="36hzxgtw5a5z">
            <HotLeadList onOpenFullList={() => setView('hotLeads')} data-id="element-16" data-mp="34ndfy2z19zs" />
          </div>}
        <div className="flex items-center gap-2 border-t border-slate-300 bg-white px-4 py-1.5" data-id="element-17" data-mp="3ucjcjtti8btq">
          <button type="button" onClick={() => setIsPanelOpen(open => !open)} aria-expanded={isPanelOpen} className="inline-flex items-center gap-2 rounded px-2.5 py-1.5 text-xs font-semibold text-slate-700 hover:bg-slate-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#0176d3]" data-id="element-18" data-mp="d3wch5cp1et0">
            <FlameIcon className="h-4 w-4 text-[#ba0517]" aria-hidden="true" data-id="element-19" data-mp="3qbfvx53mubrg" />
            Hot Lead List
            <span className="rounded-full bg-[#ba0517] px-1.5 py-0.5 text-[10px] font-bold text-white" data-id="element-20" data-mp="3lk7q0j1ih8j1">
              {urgentCount || pending.length}
            </span>
            {isPanelOpen ? <ChevronDownIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-21" data-mp="2swlgyv9ilbos" /> : <ChevronUpIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-22" data-mp="18dhpvydbqq3d" />}
          </button>
        </div>
      </div>
    </div>;
}
interface NavItemProps {
  label: string;
  isActive: boolean;
  onClick: () => void;
}
function NavItem({
  label,
  isActive,
  onClick
}: NavItemProps) {
  return <button type="button" onClick={onClick} className={`pb-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-white ${isActive ? 'border-b-2 border-white font-semibold' : 'text-white/70'}`} data-id="element-23" data-mp="13fq0pc42di2v">
      {label}
    </button>;
}